import type { Options, SeriesColumnOptions } from 'highcharts/highcharts';
import { BaseChart, type BaseChartProps } from './BaseChart';
import { useChartOptionsOverrides, useHighchartsRef, useSeriesOptions } from './hooks';
import type { SharedChartProps } from './types';

export interface ColumnChartProps extends SharedChartProps<SeriesColumnOptions>, BaseChartProps {}

const DEFAULT_COLUMNCHART_OPTIONS: Options = {
  chart: {
    type: 'column',
  },
  plotOptions: {
    column: {
      stacking: 'normal',
    },
  },
  xAxis: {
    type: 'datetime',
  },
};

export const ColumnChart: React.FC<ColumnChartProps> = ({
  series,
  seriesObservable,
  options,
  onChartCreated,
  mergeSeriesUpdates,
  ...props
}) => {
  const { chartRef, isLoaded, setChartObject } = useHighchartsRef({ onChartCreated });
  const seriesOptions = useSeriesOptions({ series, seriesObservable, chartRef, isLoaded, mergeSeriesUpdates });
  const combinedOptions = useChartOptionsOverrides(DEFAULT_COLUMNCHART_OPTIONS, options, seriesOptions);

  return <BaseChart options={combinedOptions} onChartCreated={setChartObject} chartRef={chartRef} {...props} />;
};
